<template>
  <layout-vertical>

    <router-view />

    <template #navbar="{ toggleVerticalMenuActive, isVerticalMenuActive }">
      <navbar
        :toggle-vertical-menu-active="toggleVerticalMenuActive"
        :is-vertical-menu-active="isVerticalMenuActive"
      />
    </template>

    <!-- <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    /> -->
      <div
      slot="vertical-menu-header"
      class="d-flex align-items-center justify-content-center h-100"
    >
      <div class="nav_div">
      
      <b-link class="nav_logo" to="/">
        <img :src="appLogoImage">
      </b-link>
     
      <!-- <div class="nav_brand">
      <h1 class="font-medium-5 mb-0 text-primary" id="menu_title">
        {{appName}}
      </h1>
      </div> -->
      </div>
    </div>

    <div slot="footer">
      <p class="mb-0">
         {{footer}} 
        </p>
        <p class="mb-0">
         Copyright &copy; 1998-{{ new Date().getFullYear() }} WFDC All Rights Reserved.
        </p>
    </div>
  </layout-vertical>
</template>

<script>
import {BLink, } from 'bootstrap-vue'
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
// import { $themeConfig } from '@themeConfig'
import Navbar from '../components/Navbar.vue'
import { $themeConfig } from '@themeConfig'


export default {
  components: {
    BLink,
    // AppCustomizer,
    LayoutVertical,
    Navbar,
  },
  data() {
    return {
      // showCustomizer: $themeConfig.layout.customizer,
      appName : $themeConfig.app.appName,
      appLogoImage : $themeConfig.app.appLogoImage,
      footer : $themeConfig.app.footer,
    }
  },
}
</script>

<style lang="scss">

#menu_title{
  font-size:1.3rem !important;
}
.nav_div{
  display:flex;
}
.nav_brand{
  margin-left:10px;
  margin-top:3px;
 
}


</style>
